import { render, staticRenderFns } from "./channelManagement.vue?vue&type=template&id=d4dd266a"
import script from "./channelManagement.vue?vue&type=script&lang=js"
export * from "./channelManagement.vue?vue&type=script&lang=js"
import style0 from "./channelManagement.vue?vue&type=style&index=0&id=d4dd266a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports